module.exports = __webpack_public_path__ + "static/media/15.eb3097c4.gif";